import { render, staticRenderFns } from "./LegendInfoModal.vue?vue&type=template&id=5e98b79a&scoped=true"
import script from "./LegendInfoModal.vue?vue&type=script&lang=js"
export * from "./LegendInfoModal.vue?vue&type=script&lang=js"
import style0 from "./LegendInfoModal.vue?vue&type=style&index=0&id=5e98b79a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e98b79a",
  null
  
)

export default component.exports